import api from './base';

export const usersApi = {
  createProfile: (profileData) =>
    api.post('/users/profile/create/', profileData, {
      headers: { 'Content-Type': 'application/json' },
    }),

  getProfile: (userId, token) =>
    api.get(`/users/profile/${userId}/`, {
      headers: { Authorization: `Token ${token}` },
    }),

  updateProfile: (userId, profileData, token) =>
    api.put(`/users/profile/${userId}/`, profileData, {
      headers: { Authorization: `Token ${token}` },
    }),

  deleteProfile: (userId, token) =>
    api.delete(`/users/profile/${userId}/`, {
      headers: { Authorization: `Token ${token}` },
    }),

  addTester: (username, email, additionalInfo) =>
    api.post('/users/add-tester/', {
      name: username,
      email: email,
      add_information: additionalInfo,
    }),

  getUsers: (token) =>
    api.get('/users/', {
      headers: { Authorization: `Token ${token}` },
    }),

  getUser: (userId, token) =>
    api.get(`/users/${userId}/`, {
      headers: { Authorization: `Token ${token}` },
    }),

  updateUser: (userId, userData, token) =>
    api.put(`/users/${userId}/`, userData, {
      headers: { Authorization: `Token ${token}` },
    }),

  deleteUser: (userId, token) =>
    api.delete(`/users/${userId}/`, {
      headers: { Authorization: `Token ${token}` },
    }),

  // Search users
  searchUsers: (searchTerm, token) =>
    api.get(`/users/search/?query=${searchTerm}`, {
      headers: { Authorization: `Token ${token}` },
    }),

  // Achievements and Badges
  getAchievements: (token) =>
    api.get('/users/achievements', {
      headers: { Authorization: `Token ${token}` }
    }),

  getBadges: (token) =>
    api.get('/users/badges', {
      headers: { Authorization: `Token ${token}` }
    }),

  // API Clients
  getApiClients: (token) =>
    api.get('/users/api-clients/', {
      headers: { Authorization: `Token ${token}` }
    }),

  createApiClient: (name, token) =>
    api.post('/users/api-clients/', { name }, {
      headers: { Authorization: `Token ${token}` }
    }),

  deleteApiClient: (clientId, token) =>
    api.delete(`/users/api-clients/${clientId}/`, {
      headers: { Authorization: `Token ${token}` }
    }),

  regenerateApiClientKey: (clientId, token) =>
    api.post(`/users/api-clients/${clientId}/regenerate/`, {}, {
      headers: { Authorization: `Token ${token}` }
    }),

  // Groups
  getGroups: (token) =>
    api.get('/users/groups', {
      headers: { Authorization: `Token ${token}` },
    }),

  getGroup: (groupId, token) =>
    api.get(`/users/groups/${groupId}`, {
      headers: { Authorization: `Token ${token}` },
    }),

  createGroup: (groupData, token) =>
    api.post('/users/groups', groupData, {
      headers: {
        Authorization: `Token ${token}`,
        'Content-Type': 'application/json',
      },
    }),

  updateGroup: (groupId, groupData, token) =>
    api.put(`/users/groups/${groupId}`, groupData, {
      headers: {
        Authorization: `Token ${token}`,
        'Content-Type': 'application/json',
      },
    }),

  deleteGroup: (groupId, token) =>
    api.delete(`/users/groups/${groupId}`, {
      headers: { Authorization: `Token ${token}` },
    }),

  addGroupMember: (groupId, userId, token) =>
    api.post(`/users/groups/${groupId}/members/`,
      { user_id: userId },
      {
        headers: {
          Authorization: `Token ${token}`,
          'Content-Type': 'application/json',
        },
      }
    ),

  removeGroupMember: async (groupId, userId, token) => {
    // This is a complex operation - first get group, then update
    const group = await api.get(`/users/groups/${groupId}`, {
      headers: { Authorization: `Token ${token}` },
    });

    if (!group || !group.members || !group.members.some(member => member.id === userId)) {
      return group;
    }

    const updatedMembers = group.members.filter(member => member.id !== userId);
    return api.put(`/users/groups/${groupId}`, {
      ...group,
      members: updatedMembers
    }, {
      headers: {
        Authorization: `Token ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },

  searchGroups: (searchTerm, token) =>
    api.get(`/users/groups?search=${searchTerm}`, {
      headers: { Authorization: `Token ${token}` },
    }),
};
